// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'distribute-item-center';

export const Component = () => (
  <path d='M15.218 2.922H9.375c-.431 0-.766.144-1.054.431a1.408 1.408 0 0 0-.431 1.054v15.709c0 .43.144.766.431 1.054.288.287.623.43 1.054.43h5.843a1.41 1.41 0 0 0 1.054-.43c.287-.288.431-.623.431-1.054V4.407c0-.431-.144-.766-.431-1.054a1.408 1.408 0 0 0-1.054-.431Zm.527 1.484v15.709c0 .335-.192.479-.527.479H9.375c-.335 0-.527-.144-.527-.48V4.407c0-.335.192-.479.527-.479h5.843c.335 0 .527.144.527.48ZM2.958.48v23.563c0 .335-.144.48-.48.48-.334 0-.478-.145-.478-.48V.48c0-.336.144-.48.479-.48.335 0 .479.144.479.479Zm19.636 0v23.563c0 .335-.144.48-.48.48-.334 0-.478-.145-.478-.48V.48c0-.335.144-.479.479-.479.335 0 .479.144.479.479Z' />
);

export const viewBox = '0 0 25 25';
